import { FC } from 'react'

import { Section } from 'components/section'
import { Heading } from 'components/heading'
import { Markdown } from 'components/markdown'

import classes from './main-content.module.css'

interface MainContentProps {
  title: string
  content: string
}

export const MainContent: FC<MainContentProps> = ({ content, title }) => {
  return (
    <div className={classes.container}>
      <Section className={classes.section}>
        <div>
          <Heading className={classes.title} theme="h2" component="h2">
            {title}
          </Heading>
          <Markdown>{content}</Markdown>
        </div>
        <div className={classes.imageSection}>
          <span className={classes.imageContainer} />
        </div>
      </Section>
    </div>
  )
}
